import React from "react";
import UpcomingTableHead from "./UpcomingTable/UpcomingTableHead";
import UpcomingTableBody from "./UpcomingTable/UpcomingTableBody";

const data = [
  {
    id: 1,
    code: "demo/MR-4840",
    vehicle: "Volvo01",
    workshop: "Automation",
    status: "Pending",
    start: "1/1/2025",
    estimation: "2/1/2025",
    description: "Description",
  },
  {
    id: 2,
    code: "demo/MR-4840",
    vehicle: "Volvo01",
    workshop: "Automation",
    status: "Done",
    start: "1/1/2025",
    estimation: "2/1/2025",
    description: "Description",
  },
  {
    id: 3,
    code: "demo/MR-4840",
    vehicle: "Volvo01",
    workshop: "Automation",
    status: "Upcoming",
    start: "1/1/2025",
    estimation: "2/1/2025",
    description: "Description",
  },
  {
    id: 4,
    code: "demo/MR-4840",
    vehicle: "Volvo01",
    workshop: "Automation",
    status: "Waiting",
    start: "1/1/2025",
    estimation: "2/1/2025",
    description: "Description",
  },
];
const Upcoming = () => {
  return (
    <div className="bg-white-rounded-top mt-3 table-parent">
      <div className={`table`}>
        <UpcomingTableHead />
        <div className="table-body">
          <UpcomingTableBody data={data} />
        </div>
      </div>
    </div>
  );
};

export default Upcoming;
